module.exports = __webpack_public_path__ + "static/media/locationIcon.be9dc967.svg";